import { render } from "./LanguajeSelector.vue?vue&type=template&id=822c3c74"
import script from "./LanguajeSelector.vue?vue&type=script&lang=js"
export * from "./LanguajeSelector.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__